import React from "react";
import FormInput from "./FormInput";

/******************************************************
 *
 * Champ Email
 *
 ******************************************************/

export default function EmailField({

    label = "Adresse e-mail",

    icon = "bi bi-envelope-at",

    name = "email",

    value = "",

    onChange,

    onBlur,

    error = "",

    required = false,

    disabled = false,

    readOnly = false,

    autoFocus = false,

    placeholder = "exemple@domaine.com",

    col = "col-12",

    labelCol = 4,

    inputCol = 8,

    className = ""

}) {

    //--------------------------------------------------
    // Nettoyage de la saisie
    //--------------------------------------------------

    const handleChange = (event) => {

        let value = event.target.value;

        // suppression des espaces

        value = value.replace(/\s/g, "");

        // toujours en minuscules

        value = value.toLowerCase();

        if (onChange) {

            onChange({

                ...event,

                target: {

                    ...event.target,

                    name,

                    value

                }

            });

        }

    };

    //--------------------------------------------------
    // Validation
    //--------------------------------------------------

    const handleBlur = (event) => {

        if (onBlur) {

            onBlur(event);

        }

    };

    //--------------------------------------------------

    return (

        <FormInput

            type="email"

            label={label}

            icon={icon}

            name={name}

            value={value}

            onChange={handleChange}

            onBlur={handleBlur}

            error={error}

            required={required}

            disabled={disabled}

            readOnly={readOnly}

            autoFocus={autoFocus}

            placeholder={placeholder}

            autoComplete="email"

            maxLength={120}

            col={col}

            labelCol={labelCol}

            inputCol={inputCol}

            className={className}

        />

    );

}